/* eslint-disable import/no-cycle */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import PropTypes, { element } from 'prop-types';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import TableHeader from './tableHeader';
import TableCell from './tableCell';
import Button, { ButtonTheme } from '../../atoms/button/button';
import Icon, { IconType } from '../../atoms/icon/icon';

import './table.scss';
import FormInputTypes from '../../atoms/formEnums/formInputTypes';
import Popup from '../popup/popup';
import swal from 'sweetalert';
import Toaste from '../../atoms/toast/toaste';
import { httpGet, httpPost } from '../../../store/externalCalls/httpCalls';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { storeStructure } from '../../../store/reducers';
import { hasPermission } from '../../atoms/permissionsGate/permissionsGate';
import permissionTypes from '../../atoms/permissionsGate/permissionTypes';
import _, { isArray } from 'lodash';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { appendParamsToURL, composeURL } from '../../../utils/urlTools';
import { getSearchedItems, tableEdited } from '../../../store/externalCalls/api/listTableApi';
import { useParams } from 'react-router-dom';
import { mapPagination } from '../../../store/externalCalls/api/maps';
import { updateForm } from '../../../store/actions/formActions';


/**
 * Table form component. You can edit cells, remove object rows, create new object rows,
 * filter columns and order columns
 */
const Table = (props) => {
  const {
    id,
    label,
    canRemove,
    disabled,
    canRemoveWhen,
    permissionToRemove,
    removeMessage,
    canEdit,
    canEditWhen,
    permissionToUpdate,
    configFile,
    canOpen,
    canOpenWhen,
    canModify,
    canModifyWhen,
    canChangePosition,
    canCreate,
    canCreateWhen,
    collapsable,
    permissionToCreate,
    dataSet,
    columnSet,
    onChange,
    onChangeRow,
    onChangeAndRefresh,
    onChangePosition,
    onClickEdit,
    onClickModify,
    onClickCreate,
    onClickRemove,
    onChangeDataSet,
    onClickRemoveInputRelationship,    
    onClickRow,
    onSearch,
    onSort,
    onDragEnd,
    rowHighlight,
    isSelectable,
    isMultiSelectable,
    bulkSelectable,
    maxElementsSelectable,
    onSelectUrl,
    initDataSelected,
    isDragable,
    className,
    emptyMessage,
    sortingPositionIndex,
    multiselectableValues,
    parentData,
    itemId,
    emptyButton,
    emptyButtonUrl,
    createButton,
    createButtonUrl
  } = props;

  const [newRow, setNewRow] = useState({});
  const session = useSelector((state) => state[storeStructure.Session], shallowEqual);
  const [currentDataSet, setCurrentDataSet] = useState(dataSet);
  const [filters, setFilters] = useState({});
  const [dataSelected, setDataSelected] = useState([]);
  const [bulkSelectableAll,setBulkSelectableAll] =useState(null);
  const [errors,setErrors] =useState({});
  const dispatch = useDispatch();
  const urlParams = useParams();
  const handleEnabledWhen = (data) => { 
    // If the element does not exists (undefined), it is disabled 
   if(newRow[data.field])
   {
      if(data.values === "not-null" && (newRow[data.field]!==null)){
        return false;
      }
      else
      {
        return true;
      }
   }
   else 
   {
    return true;
   }
  }
  let master=[];
  const handleCellChange = (cellChanged) => {
    const newDataSet = [...currentDataSet];
    const columnType = columnSet.find((x) => x.attributeName === cellChanged.name);
  
    if (columnType && columnType.type === FormInputTypes.RADIO) {
      newDataSet.forEach((data) => {
        // eslint-disable-next-line no-param-reassign
        data[cellChanged.name] = false;
      });
    }
    newDataSet[cellChanged.dataSetIndex][cellChanged.name] = cellChanged.newValue;
    newDataSet[cellChanged.dataSetIndex].newItem = false;
    onChange(newDataSet);
  };

  const handleChangeRefreshRecord=(cellChanged)=>{
    const newDataSet = [...currentDataSet];
    const columnType = columnSet.find((x) => x.attributeName === cellChanged.name);
  
    if (columnType && columnType.type === FormInputTypes.RADIO) {
      newDataSet.forEach((data) => {
        // eslint-disable-next-line no-param-reassign
        data[cellChanged.name] = false;
      });
    }
    newDataSet[cellChanged.dataSetIndex][cellChanged.name] = cellChanged.newValue;
    newDataSet[cellChanged.dataSetIndex].newItem = false;
    onChangeRow(newDataSet[cellChanged.dataSetIndex]);
  }

  useEffect(()=>{
     const normalizedInit = Array.isArray(initDataSelected)
    ? initDataSelected
    : initDataSelected
      ? [initDataSelected]
      : [];
    if(isMultiSelectable){
        setDataSelected(dataSet
            .filter((dSet) => normalizedInit
              .find((e) => e[itemId?itemId:"id"] === dSet[itemId?itemId:"id"]) !== undefined));
    }else{
        if(initDataSelected){
          setDataSelected(initDataSelected);
        }else{
          setDataSelected([]);
        }
      }
  },[initDataSelected]);

  const handleCellChangeInputRelationship = (cellChanged) => {
    const newDataSet = [...currentDataSet];
    const keys = columnSet[0].rowKeys;
    newDataSet[cellChanged.dataSetIndex][keys.mainKey] = (typeof cellChanged.newValue === 'object' && cellChanged.newValue !== null) ? cellChanged.newValue[keys.valueToShow] : cellChanged.newValue;
    newDataSet[cellChanged.dataSetIndex][keys.foreignKey] = (typeof cellChanged.newValue === 'object' && cellChanged.newValue !== null) ? cellChanged.newValue.id : null;
    newDataSet[cellChanged.dataSetIndex][keys.foreignKeyName] = (typeof cellChanged.newValue === 'object' && cellChanged.newValue !== null) ? [cellChanged.newValue] : null;
    onChange(newDataSet);
  };
  const handleChangeStatus = (cellChanged) => {
    onChange(cellChanged);
  };
  const handleChangeRefresh=(data)=>{
    onChangeAndRefresh(data);
  }

  const handleRowDelete = (rowIndex) => {

    if(removeMessage){
      swal({
        title: configFile?.removeTitle ?? 'Are you sure?',
        text: removeMessage,
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then((ok) => {
        if(ok){
          onClickRemove(rowIndex);
        }
      });
    }else
    onClickRemove(rowIndex);
  };

  const handleSort = (event) => {
    onSort(event);
  };




  const handleSearch = (filters) => {
        
    let newId = urlParams.id ? urlParams.id : id;
    const url = composeURL(session, configFile.sessionParams, configFile.getURL, newId);
    
    const searchURL = appendParamsToURL(url, filters);
    window.history.pushState({}, '', appendParamsToURL('', filters));
    
    // getSearchedItems(searchURL, dispatch);
    httpGet(searchURL, process.env.REACT_APP_API_ENDPOINT)
    .then((valuesRequest) => {
      let values="";
      onChangeDataSet({[configFile.attributeName]:valuesRequest[configFile.attributeName],isFilter:true});
    }).catch(() => {
      
    });

    

  };

  const handleFilter = (event) => {
    const value = event.value?.target?.value ?? "";

    const updated = {
      ...filters,
      [event.attributeName]: value,
    };

    const hasActiveFilters = Object.entries(updated).some(([key, val]) => {
      if (key === "isFilter") return false;
      return String(val ?? "").trim() !== "";
    });

    const nextFilters = { ...updated };

    if (hasActiveFilters) {
      nextFilters.isFilter = true;
    } else {
      delete nextFilters.isFilter;
    }

    setFilters(nextFilters);
    if (onSearch) onSearch(nextFilters);
    else handleSearch(nextFilters);
  };

  const handleRowEdit = (rowIndex) => {
    onClickEdit(rowIndex);
  };
  const handleRowModify = (rowIndex) => {
    onClickModify(rowIndex);
  };

  const handleEnableCreateWhen = () => {

    return canCreateWhen ? handleEnabledWhen(canCreateWhen) : false

  }

  const handleNewInputRelationshipRowChange = (cellChanged, additionalUpdates = null) => {
    const newRowState = { ...newRow };
    if (Object.keys(newRow).lenth === 0) {
      columnSet.forEach((column) => {
        newRowState[column.attributeName] = column.default;
      });
    }
    const keys = columnSet[0].rowKeys;
    newRowState[keys.mainKey] = (typeof cellChanged.newValue === 'object' && cellChanged.newValue !== null) ? cellChanged.newValue[keys.valueToShow] : cellChanged.newValue;
    newRowState[keys.foreignKey] = (typeof cellChanged.newValue === 'object' && cellChanged.newValue !== null) ? cellChanged.newValue.id : null;
    newRowState[keys.foreignKeyName] = (typeof cellChanged.newValue === 'object' && cellChanged.newValue !== null) ? [cellChanged.newValue] : null;
    if(additionalUpdates){      
      additionalUpdates.forEach((additionalUpdate)=>{
        newRowState[additionalUpdate.updateField] = additionalUpdate.relationshipField;
      });
    }

    setNewRow(newRowState);
  };

  const handleNewRowChange = (cellChanged) => {
    const newRowState = { ...newRow };
    if (Object.keys(newRow).lenth === 0) {
      columnSet.forEach((column) => {
        newRowState[column.attributeName] = column.default;
      });
    }
    newRowState[cellChanged.name] = cellChanged.newValue;

    setNewRow(newRowState);
  };

  const handlerNewRow = (event) => { 
    onClickCreate(newRow);
    setNewRow({});
  };

  const handlerClickRow = (event, clickData) => {
    if(collapsable && clickData[collapsable.key] == collapsable.values.master){      
      const slaves = document.querySelectorAll(`.collapsable-row-slave[data-collapsable-slave='${(clickData?clickData.id:"dkjsakñdfjñf")}']`);
      const toggleIcon = event.target.parentElement.parentElement.children[0].children[0]
      toggleIcon.classList.toggle('rotate-icon')

      slaves.forEach(
        slave =>  slave.classList.toggle('collapse-slave')
      )

    }

    if (isMultiSelectable) {
      const newclickData = [...initDataSelected];
      const index = newclickData.findIndex((element) => element[itemId?itemId:"id"] === clickData[itemId?itemId:"id"]);
      if (index === -1) {
        if(!maxElementsSelectable || (maxElementsSelectable && initDataSelected.length<maxElementsSelectable)){
          if(!onSelectUrl){
            newclickData.push(clickData);
            setDataSelected(dataSet
              .filter((dSet) => newclickData
                .find((e) => e[itemId?itemId:"id"] === dSet[itemId?itemId:"id"]) !== undefined));
            onClickRow(newclickData);
          }
          else{
            let params={"data":clickData,"session":session};
            httpPost(onSelectUrl, params).then((res)=>{
              newclickData.push(clickData);

              setDataSelected(dataSet
                .filter((dSet) => newclickData
                  .find((e) => e[itemId?itemId:"id"] === dSet[itemId?itemId:"id"]) !== undefined));
              onClickRow(newclickData);
             
            }).catch(error=>{
             
              setErrors([error.message]);
              
              setTimeout(() => {
                setErrors({});
                newclickData.splice(index,1);
                setDataSelected(dataSet
                  .filter((dSet) => newclickData
                    .find((e) => e[itemId?itemId:"id"] === dSet[itemId?itemId:"id"]) !== undefined));
                onClickRow(newclickData);
              }, 2000);
            });
            //
          }
        }else{
          setErrors(["Reached the max of items to be selected"]);
          setTimeout(() => {
            setErrors({});
          }, 2000);
        }
      } else {
        newclickData.splice(index, 1);
        setDataSelected(dataSet
          .filter((dSet) => newclickData
            .find((e) => e[itemId?itemId:"id"] === dSet[itemId?itemId:"id"]) !== undefined));
        onClickRow(newclickData);
      }
    } 
    else if (isSelectable) {
      const newclickData = clickData !== dataSelected ? [clickData] : undefined;
      setDataSelected(newclickData);
      onClickRow(newclickData);
    }
  };

  const handlerChagePosition = (position, dataRow) => {
    if (position) {
      const newDataRow = { ...dataRow };
      let offset=-0.1;
      if(dataRow[sortingPositionIndex]<position){
        offset=0.1;
      }
      newDataRow[sortingPositionIndex] = parseFloat(position)+offset;
      onChangePosition(newDataRow);
    }
  };

  useEffect(() => {
    if(initDataSelected && initDataSelected.length==0){
      setDataSelected([]);
    }
  },[initDataSelected]);
  useEffect(() => {
    setCurrentDataSet(dataSet);
     const normalizedInit = Array.isArray(initDataSelected)
    ? initDataSelected
    : initDataSelected
      ? [initDataSelected]
      : [];
    if (isMultiSelectable) {
      setDataSelected(dataSet
        .filter((dSet) => normalizedInit
          .find((e) => e[itemId?itemId:"id"] === dSet[itemId?itemId:"id"]) !== undefined));
    }else{
      if(initDataSelected && dataSet){
        if(isArray(initDataSelected)){
        setDataSelected(dataSet
          .filter((dSet) => normalizedInit
            .find((e) => e!=null && e[itemId?itemId:"id"] === dSet[itemId?itemId:"id"]) !== undefined));
        }else{
        setDataSelected([]);  
        }
      }else{
        setDataSelected([]);
      }
    }
  }, [dataSet]);

  const handleMultiSelectable=(elem,clickData)=>{
    handlerClickRow(null,clickData);
  }

  const handleSelectAll=(value)=>{
    selectAllRecords(value);
    setBulkSelectableAll(value==true?"yes":"no");
  }
  const selectAllRecords=(value)=>{
    if(value==true){
      setDataSelected(dataSet);
      onClickRow(dataSet);
    }else{
      setDataSelected([]);
      onClickRow([]);
    }
  }
  const handleCloseToast=()=>{
    setErrors([]);
  }
  const checkEnabledWhen=(dataRow,enabledWhen)=>{
    let result=false;
    for(let i=0;i<enabledWhen.length;i++){
      if(enabledWhen[i].values.includes(dataRow[enabledWhen[i].field])){
        result=true;
        break;
      }
    }
    return result;
  }
  const getPreviousNonNull=(arr, currentIndex)=> {
    for (let i = currentIndex - 1; i >= 0; i--) {
        if (arr[i] !== null) {
            return arr[i]; // Return the first non-null value found
        }
    }
    return null; // Return null if no previous non-null value exists
  }
  return (
    <div>
      {Object.keys(errors).length > 0
      && (
        <Toaste type="error" mode="toast" data={errors} onClose={handleCloseToast} />
      )}
      <table className={`table table-hover ${className}`} id={id}>
        <thead>      
          <tr>
          {collapsable && <th>View</th>} 
            {bulkSelectable && 
              <TableHeader
              tableId={id}
              key={`${label}-headerMultiselectable`}
              attributeName={`${label}-headerMultiselectable`}
              label={"Sel"}
              multiselectable={bulkSelectable}
              bulkValue={bulkSelectableAll}
              canEdit={true}
              hidden={false}
              exactWidth={"30px"}
              helpText={"Select all records" }
              onUpdateMultiselectable={handleSelectAll}
              initDataSelected={initDataSelected}
              small={true}
            />
            }
            {
              columnSet.map((column, i) => {
                if(column.visibleWhen){
                  if(dataSet.length>0 && (column.visibleWhen["value"]!="bool-false" && column.visibleWhen["value"]!="bool-true") && dataSet[0][column.visibleWhen["field"]]!=column.visibleWhen["value"] && column.visibleWhen["value"]!="not-null"){
                    delete column[i];
                    return null;
                  }else if(dataSet.length>0 && column.visibleWhen["value"]=="bool-false" && dataSet[0][column.visibleWhen["field"]]==true){
                    delete column[i];
                    return null;
                  }else if(dataSet.length>0 && column.visibleWhen["value"]=="bool-true" && dataSet[0][column.visibleWhen["field"]]==false){
                    delete column[i];
                    return null;
                  }
                }
                return (
                <TableHeader
                  tableId={id}
                  type={column.type}
                  key={`${label}col${i}`}
                  attributeName={column.attributeName}
                  label={column.label}
                  canEdit={column.canEdit}
                  canOrder={column.canOrder}
                  hidden={column.hidden}
                  onSort={handleSort}
                  filterSelectOptions={column.filterSelectOptions}
                  canFilter={column.canFilter}
                  onFilter={handleFilter}
                  width={column.width}
                  exactWidth={column.exactWidth}
                  helpText={column.helpText}
                  small={column.small}
                  additionalCss={column.additionalCss}
                />
              )})
            }
            { (canRemove || canOpen || canCreate || canChangePosition)
            && <th className="table__options">Options</th>}
          </tr>
        </thead>
        {canCreate && (permissionToCreate.length === 0 || hasPermission(permissionToCreate)) && (
          <tbody>
            <tr key="createRow" className="bg-primary">
              {bulkSelectable && <td />}
              {columnSet.map((column, j) => {
                if (column.canCreate) {
                  return (
                    <TableCell
                      dataSet={dataSet}
                      key={`${label}newcell${j}`}
                      id={`${id}-new-${column.attributeName}`}
                      configFile={column}
                      dataSetIndex={currentDataSet.length}
                      value={
                        newRow[column.attributeName] !== undefined
                          ? newRow[column.attributeName] : column.default
                      }
                      canEdit
                      fileType={column.fileType}
                      onChange={handleNewRowChange}
                      onEnableWhen={handleEnabledWhen}
                      onChangeInputRelationship={handleNewInputRelationshipRowChange}
                      pattern={column.pattern}
                      additionalCss={column.additionalCss}
                      width={column.width}
                      exactWidth={column.exactWidth}
                    />
                  );
                }
                return (<td key={`${label}newcell${j}`} />);
              })}
              <td>
                <Button
                  id={`${id}-new-button`}
                  onClick={handlerNewRow}
                  theme={ButtonTheme.SECONDARY}
                  icon={IconType.NEW}
                  disabled={disabled ? disabled : handleEnableCreateWhen()}
                />
              </td>
            </tr>
          </tbody>
        )}
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided) => (
              <tbody
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                 {provided.placeholder}
                {
                  currentDataSet.map((dataRow, i) => {
                    let canOpenEnabled=true;
                    let canEditEnabled=true;
                    let canRemoveEnabled=true;
                    let canModifyEnabled=true;
                    if(canOpenWhen!=null)
                      canOpenEnabled=checkEnabledWhen(dataRow,canOpenWhen);
                    if(canEditWhen!=null)
                      canEditEnabled=checkEnabledWhen(dataRow,canEditWhen);
                    if(canRemoveWhen!=null)
                      canRemoveEnabled=checkEnabledWhen(dataRow,canRemoveWhen);
                    
                    if(canModifyWhen!=null)
                      canModifyEnabled=checkEnabledWhen(dataRow,canModifyWhen);
                    if(collapsable){
                      if(collapsable.values.master == dataRow[collapsable.key]){
                        master[i]=dataRow.id;
                      }else{
                        master[i]=getPreviousNonNull(master,i);
                      }
                    }
                    const rowKey = itemId || "id";
                    const isRowSelected = Array.isArray(dataSelected)
                      ? dataSelected.some((selected) => selected?.[rowKey] === dataRow?.[rowKey])
                      : dataSelected?.[rowKey] === dataRow?.[rowKey];
                    return (
                    <Draggable key={`${label}row${i}`} draggableId={`${label}row${i}`} index={i} isDragDisabled={!isDragable}>
                      {(providedDragable) => (                        
                        <tr
                          data-collapsable-id={dataRow.id}
                          data-collapsable-master={dataRow[collapsable?.key] == collapsable?.values.master?master[i]:null}    
                          data-collapsable-slave={dataRow[collapsable?.key] == collapsable?.values.slave?master[i]:null}
                          key={`${label}row${i}`}
                          id={`${id}-${i}`}
                          onClick={(event) => handlerClickRow(event, dataRow)}
                          className={
                            (dataRow.newItem === true ? 'alert-warning table__row--change-to-transparent' : '')
                            + (dataSelected === dataRow
                            || (isMultiSelectable
                              && dataSelected.findIndex((e) => e === dataRow) !== -1) 
                              ? ' table__row--selected ' : ''
                            )
                            +((isMultiSelectable==false && dataSelected && isRowSelected)?
                              " table__row--selected ":"")
                            + (rowHighlight ? rowHighlight.map (
                              row => dataRow[row.key] === row.value ? ` ${row.class}`: ''
                              ).join(' ') : '')
                            + (collapsable?.values.master == dataRow[collapsable?.key] ? ' collapsable-row-master' : ' collapsable-row-slave')
                            
                          }
                          ref={providedDragable.innerRef}
                          {...providedDragable.draggableProps}
                          {...providedDragable.dragHandleProps}
                        >
                          {collapsable &&
                          <td 
                            data-collapsable
                            key={`${label}-cell-collapsable-multiselectable`}
                            id={`${label}-cell-collapsable-multiselectable`}>
                              {(collapsable?.values.master == dataRow[collapsable?.key] ? <Icon icon={IconType.ANGLE_DOWN} /> : '')}
                          </td>}

                          {bulkSelectable && 
                            <TableCell
                              key={`${label}cell-multiselectable`}
                              id={`${label}-cell-multiselectable`}
                              configFile={{type:FormInputTypes.CHECKBOX}}
                              dataSetIndex={i}
                              dataSet={dataSet}
                              hidden={false}
                              value={dataSelected === dataRow || (dataSelected === dataRow
                                || (isMultiSelectable
                                  && dataSelected.findIndex((e) => e === dataRow) !== -1)
                                  ? true : false
                                )}
                              canEdit={true}
                              canCreate={false}
                              onChange={()=>{handleMultiSelectable(i,dataRow)}}
                              disabled={false}
                              small={true}
                              />
                          }
                          {
                            columnSet.map((column, j) => {
                              if(column.visibleWhen){
                                  if((column.visibleWhen["value"]!="bool-true" && column.visibleWhen["value"]!="bool-false") && dataRow[column.visibleWhen["field"]]!=column.visibleWhen["value"]){
                                    delete column[i];
                                    return null;
                                  }else if (column.visibleWhen["value"]=="bool-false" && dataRow[column.visibleWhen["field"]]==true){
                                    console.log("1");
                                     delete column[i];
                                    return null;
                                  }else if(column.visibleWhen["value"]=="bool-true" && dataRow[column.visibleWhen["field"]]==false){
                                     delete column[i];
                                    return null;
                                  }else{
                                    // console.log("pepe");
                                  }
                              }
                              return (
                                <TableCell
                                  key={`${label}cell${j}`}
                                  id={`${id}-${i}-${column.attributeName}`}
                                  configFile={column}
                                  dataSetIndex={i}
                                  dataSet={dataSet}
                                  fileType={column.fileType}
                                  hidden={column.hidden}
                                  value={dataRow[column.attributeName] !== undefined ? dataRow[column.attributeName] : ''}
                                  secondaryValue={dataRow[column.secondaryValue]}
                                  canEdit={canEdit && column.canEdit && (permissionToUpdate.length == 0 || hasPermission(permissionToUpdate))}
                                  onChange={handleCellChange}
                                  onChangeAndRefreshRecord={handleChangeRefreshRecord}
                                  onChangeInputRelationship={handleCellChangeInputRelationship}
                                  onChangeStatus={handleChangeStatus}
                                  onChangeAndRefresh={handleChangeRefresh}
                                  multiple={column.multiple}
                                  pattern={column.pattern}
                                  width={column.width}
                                  exactWidth={column.exactWidth}
                                  colors={column.colors}
                                  hasSelect={column.hasSelect}
                                  valueButton={column.valueButton}
                                  textAreYouSure={column.textAreYouSure}
                                  buttonText={column.buttonText}
                                  actionUrl={column.actionUrl}
                                  relatedId={dataRow.id}
                                  disabled={column.disabled}
                                  enabledWhen={column.enabledWhen}
                                  small={column.small}
                                  refreshRowOnChange={column.refreshRowOnChange}
                                  additionalCss={column.additionalCss}
                                />
                            )})
                          }
                          { (canRemove || canChangePosition || canOpen || canCreate || canModify)
                          && (
                          <td style={{width:'100px'}}> 
                            { canChangePosition && sortingPositionIndex !== ''
                            && (
                              <div className="d-inline position-relative">
                                <Popup
                                  title="Send to position"
                                  id={`${id}-${i}-position`}
                                  type={FormInputTypes.TEXT_INPUT.NUMBER}
                                  onChange={(position) => handlerChagePosition(position, dataRow)}
                                />

                              </div>
                            )}
                            {
                              canOpen
                              && (
                              <Button
                                id={`${id}-${i}-openButton`}
                                dataId={dataRow["id"]}
                                className="mr-1"
                                disabled={!canOpenEnabled}
                                theme={ButtonTheme.INFO}
                                icon={IconType.EDIT}
                                onClick={() => handleRowEdit(dataRow)}
                              />
                              )
                            }
                            {
                              canModify
                              && (
                              <Button
                                id={`${id}-${i}-modifyButton`}
                                className="mr-1"
                                dataId={dataRow["id"]}
                                disabled={!canModifyEnabled}
                                theme={ButtonTheme.SECONDARY}
                                icon={IconType.ELLIPSIS}
                                onClick={() => handleRowModify(dataRow)}
                              />
                              )
                            }
                            { canRemove && (permissionToRemove.length == 0 || hasPermission(permissionToRemove))
                            && (
                              <Button
                                id={`${id}-${i}-removeButton`}
                                dataId={dataRow["id"]}
                                theme={ButtonTheme.ERROR}
                                icon={IconType.DELETE}
                                disabled={!canRemoveEnabled}
                                onClick={() => handleRowDelete(dataRow)}
                              />
                            )}
                          </td>
                          )}
                        </tr>                        
                      )}
                    </Draggable>
                    )
})
                }
               
              </tbody>
            )}
          </Droppable>
        </DragDropContext>
      </table>
      { currentDataSet.length === 0
        && (
          <div className="table__empty-row">
            {emptyMessage}
             {emptyButton && emptyButtonUrl && (
              <a
                className="btn btn-primary btn-sm ml-3"
                href={emptyButtonUrl}
              >
                {emptyButton}
              </a>
            )}
          </div>

        )}
      { currentDataSet.length > 0
        && (
          <div className="">
             {createButton && createButtonUrl && (
              <a
                className="btn btn-primary btn-sm ml-3"
                href={createButtonUrl}
              >
                {createButton}
              </a>
            )}
          </div>

        )}
    </div>
  );
};

Table.propTypes = {
  /**
   * component id
   */
  id: PropTypes.string,
  /**
   * Label table name
   */
  label: PropTypes.string,
  /**
   * Can remove items
   */
  canRemove: PropTypes.bool,
   /**
   * permission to control the remove action
   */
  permissionToRemove: PropTypes.arrayOf(PropTypes.string),
  /**
   * Can open the item details pages
   */
  canOpen: PropTypes.bool,
  /**
  * Can open the item details pages
  */
  canModify: PropTypes.bool,
  /**
   * Can change the position of the item
  */
  canChangePosition: PropTypes.bool,
  /**
   * Make a row to create new items inside the table
   */
  canCreate: PropTypes.bool,
  /**
   * permission to control the create action
   */
  permissionToCreate: PropTypes.arrayOf(PropTypes.string),
  /**
   * Can edit the item inside the table
   */
  canEdit: PropTypes.bool,
  /**
   * permission to control the update action
   */
  permissionToUpdate: PropTypes.arrayOf(PropTypes.string),
  /**
   * Data set objects to show inside the table
   */
  dataSet: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * Define the colums to draw inside the table
   */
  columnSet: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * Data set change event
   */
  onChange: PropTypes.func,
  onChangeRow:PropTypes.func,
  /**
   * Data set change event
   */
  onChangePosition: PropTypes.func,
  /**
   * On click row event
   */
  onClickEdit: PropTypes.func,
  /**
   * On Click new row
   */
  onClickCreate: PropTypes.func,
  /**
   * On click remove event
   */
  onClickRemove: PropTypes.func,
  /**
   * On click remove event
   */
  onClickRemoveInputRelationship: PropTypes.func,
  /**
   * On drag event, its fire when a row was moved
   */
  onDragEnd: PropTypes.func,
  /**
   * On search event, get the filters used by the user
   */
  onSearch: PropTypes.func,
  /**
   * On sort event, it sorts in ascending order
   */
  onSort: PropTypes.func,
  /**
   * if it's true, the user can select a row
   */
  isSelectable: PropTypes.bool,
  /**
   * if it's true, the user can select a row
   */
  isMultiSelectable: PropTypes.bool,
  initDataSelected: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({})), PropTypes.object]),
  onSelectUrl:PropTypes.string,
  /**
   * If it's true, the table is sorteable
   */
  isDragable: PropTypes.bool,
  /**
   * Event function with the row object selected
   */
  onClickRow: PropTypes.func,
  /**
   * custom css class
   */
  className: PropTypes.string,
  /**
   * Message when the table is empty
   */
  emptyMessage: PropTypes.string,
   /**
   * Href when the table is empty
   */
  emptyButtonUrl: PropTypes.string,
  /**
   * Href for create new
   */
  createButton: PropTypes.string,
   /**
   * Href for create button
   */
  createButtonUrl: PropTypes.string,
  /**
   * Href when the table is empty
   */
  emptyButton: PropTypes.string,
  /**
   * If canChangePosition is true, position index has the index to sort the table
   */
  sortingPositionIndex: PropTypes.string,
};

Table.defaultProps = {
  id: '',
  label: '',
  className: '',
  canRemove: false,
  permissionToRemove: [],
  canEdit: false,
  permissionToUpdate: [],
  canCreate: false,
  permissionToCreate: [],
  canOpen: false,
  canModify: false,
  canChangePosition: false,
  onChange: () => {},
  onChangeRow:()=>{},
  onChangePosition: () => {},
  onClickEdit: () => {},
  onClickRemove: () => {},
  onClickRemoveInputRelationship: () => {},
  onClickCreate: () => {},
  onClickRow: () => {},
  onDragEnd: () => {},
  onSort: () => {},
  isSelectable: false,
  isMultiSelectable: false,
  onSelectUrl:null,
  isDragable: false,
  emptyMessage: "You don't have items!",
  emptyButtonUrl:"",
  initDataSelected: [],
  sortingPositionIndex: '',
};

export default Table;
